var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbolpackNew315({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}.b{fill:none;stroke:#fff;stroke-miterlimit:10;stroke-width:0.5px;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1.59,5.63V2.79H.72V2.41H2.81v.38H1.94V5.63Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M3.16,5.63V2.41h.52l.63,2.28.12.48.14-.52.64-2.24h.47V5.63H5.34V2.94L4.57,5.63H4.26L3.49,2.89V5.63Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M7,5.63,6,2.41h.38L7,4.75c0,.18.1.36.14.53,0-.18.09-.36.14-.53L8,2.41h.36l-1,3.22Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M7.47,7.45a4.32,4.32,0,0,0,0,6.11l3.06-3.06Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M7.47,13.56a4.32,4.32,0,0,0,6.11,0L10.53,10.5Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M7.47,7.45l3.06,3.05,3.05-3A4.32,4.32,0,0,0,7.47,7.45Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M13.58,13.56a4.32,4.32,0,0,0,0-6.11L10.53,10.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolpackNew315);
export default __webpack_public_path__ + "static/media/Symbolpack_New_315.37c9baa04ee8c8ab830b305d730ec562.svg";
export { ForwardRef as ReactComponent };